import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import TopBarNav from "../common/TopBarNav";
import {
  Backdrop,
  Button,
  CircularProgress,
  Container,
  Grid,
  InputAdornment,
  Tab,
  Tabs,
  withStyles,
  Input,
  FormControl,
} from "@material-ui/core";
import { useHistory } from "react-router-dom";
import PurchaseStyles from "./PurchaseStyles";
import { connect } from "react-redux";
import { WhiteSpace } from "antd-mobile";
import DatePicker from "antd/es/date-picker";
import * as purchaseActions from "../../actions/purchase/PurchaseActions";
import * as navigationActions from "../../actions/common/NavigationActions";
import * as notificationActions from "../../actions/notifications/NotificationsActions";
import { bindActionCreators } from "redux";
import { TimePicker } from "antd";
import moment from "moment";
import Modal from "antd/es/modal";
import { toast, ToastContainer } from "react-toastify";
import BreadcrumbsHistory from "../common/BreadcrumbsHistory";
import PurchaseUploadInvoice from "./Invoices/PurchaseUploadInvoice";
import InboxIcon from "@material-ui/icons/Inbox";
import DataTable from "react-data-table-component";
import {
  getUploadPurchaseEvidenceTableColumns,
  getConstantsPurchase,
} from "../common/Utils";
import PurchaseOrderDetailGeneral from "./PurchaseOrderDetailGeneral";
import PurchaseOrderDetailClientInformation from "./PurchaseOrderDetailClientInformation";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Tooltip from '@material-ui/core/Tooltip';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import { useTranslation } from "react-i18next";
import Badge from "@material-ui/core/Badge";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import { styled } from "@mui/material/styles";
import { format, compareAsc, parseISO } from "date-fns";

import TablePagination from "@mui/material/TablePagination";
import { ExpandLessOutlined } from "@material-ui/icons";

import useAuth  from '../../hooks/useAuth';
import queryString from 'query-string';
import { VERIFICATION_STATUS } from "../../Constants/verificationStatus"; //PR-26005 - Asalas :P2MOAC-267 

const paginationOptions = {
  rowsPerPageText: "Filas por página",
  rangeSeparatorText: "de",
  selectAllRowsItem: true,
  selectAllRowsItemText: "Todos",
};

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      style={{ width: "200%" }}
      {...other}
    >
      {value === index && (
        <>
          <WhiteSpace size="lg" />
          <WhiteSpace size="lg" />
          <Container maxWidth="lg">
            <Grid container item xs={12}>
              {children}
            </Grid>
          </Container>
        </>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

const PurchaseOrderDetail = ({ classes, ...props }) => {
  const [value, setValue] = useState(0);
  const [deliveryDate, setDeliveryDate] = useState(null);
  const [deliveryTentativeDate, setDeliveryTentativeDate] = useState(null);
  const [platesDate, setPlatesDate] = useState(null);
  const [orderDate, setOrderDate] = useState(null);
  const [invoiceDate, setInvoiceDate] = useState(null);
  const [verificationDate, setVerificationDate] = useState(null);
  const [verificationNextDate, setVerificationNextDate] = useState(null);
  const [hour, setHour] = useState("");
  const {
    match: { params },
  } = props;
  const history = useHistory();
  const [loading, setOpenLoading] = useState(false);
  const [rightPaymentFile, setRightPaymentFile] = useState(null);
  const [circulationTargetFile, setCirculationTargetFile] = useState(null);
  const [platesFile, setPlatesFile] = useState(null);
  const [verificationFile, setVerificationFile] = useState(null);
  const [plateNumber, setPlateNumber] = useState("");
  const [showtabs, getShowTabs] = useState();
  const [disabledDeliveryDates, setDisabledDeliveryDates] = useState(false);
  const [disabledAnnexButton, setDisabledAnnexButton] = useState(true);
  const [disableBtn, setDisableBtn] = useState(true);
  const [disableDt, setDisableDt] = useState(true);
  const [disabledDeliveryTentativeDate, setDisabledDeliveryTentativeDate] = useState(true);
  const [disableDtBtn, setDisableDtBtn] = useState(true); //P2MSPFE-4420
  const [annexbFile, setAnnexbFile] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);

  const [disabledRightPayment, setDisabledRightPayment] = useState(false);
  const [disabledCirculationTarget, setDisabledCirculationTarget] =
    useState(false);
  const [disabledPlates, setDisabledPlates] = useState(false);

  const [disabledPlatesByApproval, setDisabledPlatesByApproval] =
    useState(true);
  const [disabledVerificationByApproval, setDisabledVerificationByApproval] =
    useState(true);
    const [disabledVerificationNextDate, setDisabledVerificationNextDate] =
    useState(true);
  const [actualDate, setActualDate] = useState(new Date());
  const { t } = useTranslation();
  const [invisible, setInvisible] = React.useState(false);

  //Enable and Disable UploadFile
  const [disablePlts, setDisablePlts] = useState(true);
  const [disableCT, setDisableCT] = useState(true);
  const [disableRP, setDisableRP] = useState(true);
  const [disableBtnSave, setDisableBtnSave] = useState(true);
  const [disableBtnUpld, setDisableBtnUpld] = useState(true);
  const [disablePltsNmbr, setDisablePltsNmbr] = useState(true);
  const [disableVr, setDisableVr] = useState(true);
  const [disableVCD, setDisableVCD] = useState(true);
  
  const [disableSendVerification, setDisableSendVerification] = useState(true); //PR-26005 - Asalas :P2MOAC-267

  //Enable & Disable Plates Grid and Verification Grid
  const [platesCmpnt, setPlatesCmpnt] = useState(false);
  const [verificationCmpnt, setVerificationCmpnt] = useState(false);

  //Enable & Disable Annexo B
  const [showAnnexoB, setShowAnnexoB] = useState(false);
  const [isInvoice, setIsInvoice] = useState(false);

  //P2MSPFE-4420
  const [stageId, setStageId] = React.useState(null);   

  const fetchStageId = () => {
    if (props.orderDetail.nvpQuoteMultipleunits) {
      props.purchaseActions.fetch_StageId(
        props.userLanguage,
        props.userToken,
        props.orderDetail.nvpQuoteMultipleunits,
        onErrorStageId,
        onSuccessStageId
      )
    }
  }

  const fecthDataForTab = () => {
    handleOpen();
    const newRoute = {
      path: "/purchase/orderDetail",
      linkLegend: "Detalle",
      urlParams: [{ key: "orderId", value: params.orderId }],
    };
    props.navigationActions.add_route(newRoute);
    props.purchaseActions.fetch_order_detail(
      props.userLanguage,
      props.userToken,
      params.orderId,
      onError,
      result
    );    
    return () => {
      props.cleanUserProfile();
    };
  };

  const { isOCA, isOCV, isOCVA } = useAuth(props.orderDetail);

  useEffect(() => {
    let date = actualDate.getDate();
    let month = actualDate.getMonth() + 1;
    let year = actualDate.getFullYear();
    let actualDateShort = `${year}${"-"}${month < 10 ? `0${month}` : `${month}`
      }${"-"}${date < 10 ? `0${date}` : `${date}`}`;
    setActualDate(actualDateShort);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    handleOpen();
    const newRoute = {
      path: "/purchase/orderDetail",
      linkLegend: "Detalle",
      urlParams: [{ key: "orderId", value: params.orderId }],
    };
    props.navigationActions.add_route(newRoute);
    props.purchaseActions.fetch_order_detail(
      props.userLanguage,
      props.userToken,
      params.orderId,
      onError,
      handleClose
    );
    return () => {
      props.cleanUserProfile();
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (props.orderDetail.nvpQuoteMultipleunits) {
      props.notificationActions.fetch_NotificationStatus(
        props.userLanguage,
        props.userToken,
        params.orderId,
        props.orderDetail.nvpQuoteMultipleunits,
        1,
        onError,
        handleClose
      );
      props.notificationActions.fetch_NotificationDetail(
        props.userLanguage,
        props.userToken,
        params.orderId,
        props.orderDetail.nvpQuoteMultipleunits,
        100,
        onError,
        handleClose
      );
      // props.notificationActions.fetch_NotificationDetail(props.userLanguage, props.userToken, 74, 524708,100, onError, handleClose)

      //P2MSPFE-4420
      props.purchaseActions.fetch_StageId(
        props.userLanguage,
        props.userToken,
        props.orderDetail.nvpQuoteMultipleunits,
        onErrorStageId,
        onSuccessStageId
      );
    }

      const urlParams = queryString.parse(props.location.search);
      setIsInvoice(urlParams.isInvoice === '1');
    let isVerificationDate = false,
      isPlatesDate = false,
      isDeliveryDate = false;
    if (props.orderDetail.verificationTentativeDate) {      
      setVerificationDate(
        moment(props.orderDetail.verificationTentativeDate, "YYYY-MM-DD")
      );
    } else {      //PR-26005 - Asalas :P2MOAC-267 - P2MOAC-3004 bug fix
      setVerificationDate(null);
    }

    if (props.orderDetail.verificationTentativeNextDate) {
      setVerificationNextDate(
        moment(props.orderDetail.verificationTentativeNextDate, "YYYY-MM-DD")
      );
    } else {    //PR-26005 - Asalas :P2MOAC-267 - P2MOAC-3004 bug fix
      setVerificationNextDate(null);
    }

    //PR-26005 - Asalas :P2MOAC-267
    //Fecha de verificación Aprobada o Enviada a NVP
    if (props.orderDetail.verificationStatus === VERIFICATION_STATUS.APROBADA || props.orderDetail.verificationStatus === VERIFICATION_STATUS.ENVIADA) {
      isVerificationDate = true;
    }

    if (props.orderDetail.platesTentativeDate) {
      setPlatesDate(
        moment(props.orderDetail.platesTentativeDate, "YYYY-MM-DD")
      );
    }
    //Fecha de placas aprobada
    if (props.orderDetail.platesStatus === 1) {
      isPlatesDate = true;
    }
    if (props.orderDetail.deliveryDate) {
      setDeliveryDate(moment(props.orderDetail.deliveryDate, "YYYY-MM-DD"));
      setHour(
        moment(new Date(props.orderDetail.deliveryDate)).format("hh:mm:ss")
      );
      isDeliveryDate = true;
    }
    if (props.orderDetail.deliveryTentativeDate) {
      setDeliveryTentativeDate(
        moment(props.orderDetail.deliveryTentativeDate, "YYYY-MM-DD")
      );
    }
    if (props.orderDetail.orderDate) {
      setOrderDate(moment(props.orderDetail.orderDate, "YYYY-MM-DD"));
    }
    if (props.orderDetail.invoiceDate) {
      setInvoiceDate(moment(props.orderDetail.invoiceDate, "YYYY-MM-DD"));
    }
    if (
        getConstantsPurchase("OCCanceled") === props.orderDetail.orderStatusId || urlParams.isInvoice === '1'
    ) {
      getShowTabs(false);
    } else {
      getShowTabs(true);
    }
    

    //Deshabilita fecha y hora real de entrega tomando en cuenta si son requeridas y si ya tienen fechas previas al igual si ya cuenta con Anexo B
    if (props.orderDetail.platesRequired) {
      if (props.orderDetail.verificationRequired) {
        if (isPlatesDate && isVerificationDate) {
          if (isDeliveryDate) {
            setDisabledDeliveryDates(true);
          } else {
            if (props.orderDetail.annexB) {
              setDisabledDeliveryDates(false);
            } else {
              setDisabledDeliveryDates(true);
            }
          }
        } else {
          setDisabledDeliveryDates(true);
        }
      } else {
        if (isPlatesDate) {
          if (isDeliveryDate) {
            setDisabledDeliveryDates(true);
          } else {
            if (props.orderDetail.annexB) {
              setDisabledDeliveryDates(false);
            } else {
              setDisabledDeliveryDates(true);
            }
          }
        } else {
          setDisabledDeliveryDates(true);
        }
      }
    }

    //Habilita AnexoB cuando fecha proramada de entrega este aprobada
    if (props.orderDetail.deliveryTentativeDateStatus === 1) {
      setDisableBtn(false);
      if (props.orderDetail.annexB === null) {
        setDisabledAnnexButton(false);
      }
    }
    
    //P2MSPFE-4420
    if(props.orderDetail !== null && stageId !== null){      
      gridValidations(props.orderDetail, stageId);
      validateSendVerificationButton(props.orderDetail);    //PR-26005 - Asalas :P2MOAC-267 - P2MOAC-3004 bug fix
    }
  }, [props.orderDetail, stageId]); // eslint-disable-line react-hooks/exhaustive-deps

  
  useEffect(() => {
    setDisabledRightPayment(false);
    setDisabledCirculationTarget(false);
    setDisabledPlates(false); // eslint-disable-next-line
    props.platesEvidence
      .filter((x) => x.evidenceType !== "verificationStub")
      .map((item, index) => {
        switch (item.evidenceType) {
          case "rightPayment":
            setDisabledRightPayment(true);
            break;
          case "CirculationTarget":
            setDisabledCirculationTarget(true);
            break;
          case "Plates":
            setDisabledPlates(true);
            break;
          default:
            break;
        }
      });
  }, [props.platesEvidence]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    const fetchData = () => {
      if (props.orderDetail) {
        if (props.orderDetail.nvpQuoteMultipleunits) {
          props.notificationActions.fetch_NotificationStatus(
            props.userLanguage,
            props.userToken,
            params.orderId,
            props.orderDetail.nvpQuoteMultipleunits,
            1,
            onError,
            handleClose
          );
          props.notificationActions.fetch_NotificationDetail(
            props.userLanguage,
            props.userToken,
            params.orderId,
            props.orderDetail.nvpQuoteMultipleunits,
            100,
            onError,
            handleClose
          );
        }
      }
      if (props.notificationStatus) {
        if (props.notificationStatus.notifications !== 0) {
          setInvisible(true);
        } else {
          setInvisible(false);
        }
      } else {
        setInvisible(false);
      }
    };

    const interval = setInterval(fetchData, 300000);
    return () => {
      clearInterval(interval);
    };
  }, [
    props.notificationStatus,
    props.notifications,
    props.orderDetail,
    props.userProfile,
  ]); // eslint-disable-line react-hooks/exhaustive-deps

  
  //PR-26005 - Asalas :P2MOAC-267
  const canEditVerification = (statusCode) => {
    return statusCode === VERIFICATION_STATUS.NO_ENVIADA || statusCode === VERIFICATION_STATUS.RECHAZADA;
  };

  //PR-26005 - Asalas :P2MOAC-267
  const isReadOnlyVerification = (statusDesc) => {
    return statusDesc === VERIFICATION_STATUS.APROBADA || statusDesc === VERIFICATION_STATUS.ENVIADA;
  };

  //PR-26005 - Asalas :P2MOAC-267 -P2MOAC-2651
  const isLocked = isReadOnlyVerification( props.orderDetail?.verificationStatus);

  //PR-26005 - Asalas :P2MOAC-267 -P2MOAC-2651
  const isSaveDisabled =  !verificationDate ||  isLocked;
  
  //PR-26005 - Asalas :P2MOAC-267 -P2MOAC-2651
  useEffect(() => {
    const hasDate = verificationDate !== null;

    const canEdit =
      hasDate &&
      canEditVerification(props.orderDetail?.verificationStatus);

    setDisabledVerificationNextDate(!canEdit);

    if (!verificationDate) {
      setVerificationNextDate(null);
      setDisableSendVerification(true);
    }
  }, [
    verificationDate,
    props.orderDetail?.verificationTentativeDate,
    props.orderDetail?.verificationStatus
  ]);

  //PR-26005 - Asalas :P2MOAC-267 - P2MOAC-3004 bug fix
  const validateSendVerificationButton = (orderDetail) => {

    const hasVerificationDate = orderDetail.verificationTentativeDate !== null;

    const hasVerificationNextDate = orderDetail.verificationTentativeNextDate !== null;

    const hasVerificationStub = orderDetail.evidences?.some(
                                    (x) => x.evidenceType === "verificationStub"
                                );
    const canEdit =
        canEditVerification(orderDetail.verificationStatus);


    if(!hasVerificationDate || !hasVerificationNextDate || !hasVerificationStub ||
        !canEdit
    ){
        setDisableSendVerification(true);
    }
    else{
        setDisableSendVerification(false);
    }
  };

  const gridValidations = (orderDetail,stageId) => {
        
    if (orderDetail.platesRequired && orderDetail.verificationRequired) {
      setPlatesCmpnt(false);
      setVerificationCmpnt(false);
      
      if (orderDetail.approvedInvoices) {
        enablePlatesCmpnts();

        if (orderDetail.platesStatus === 1) {
          enableVerificationCmpnts();
          disablePlatesCmpnts();

          //PR-26005 - Asalas :P2MOAC-267
          if (canEditVerification(orderDetail.verificationStatus )) 
              enableVerificationCmpnts();
          else 
              disableVerificationCmpnts();

        }
        else {
          enablePlatesCmpnts();
          disableVerificationCmpnts();
        }
          
        //PR-26005 - Asalas :P2MOAC-267 
        if (orderDetail.platesStatus === 1 && orderDetail.verificationStatus  === VERIFICATION_STATUS.APROBADA) {
          setDisabledDeliveryTentativeDate(false);
        }
        else {
          setDisabledDeliveryTentativeDate(true);
        }

        

      }
      else {
        disablePlatesCmpnts();
        disableVerificationCmpnts();
        setDisabledDeliveryTentativeDate(true);
      }

    }
    if (!orderDetail.platesRequired && !orderDetail.verificationRequired) {
      setPlatesCmpnt(true);
      setVerificationCmpnt(true);
      disablePlatesCmpnts();
      disableVerificationCmpnts();
      setDisabledDeliveryTentativeDate(false);
    }
    if (orderDetail.platesRequired && !orderDetail.verificationRequired) {
      setPlatesCmpnt(false);
      setVerificationCmpnt(true);

      if (orderDetail.approvedInvoices) {
        enablePlatesCmpnts();

        if (orderDetail.platesStatus === 1) {
          disablePlatesCmpnts();
          setDisabledDeliveryTentativeDate(false);
        }
        else {
          enablePlatesCmpnts();
          setDisabledDeliveryTentativeDate(true);
        }

      }
      else {
        disablePlatesCmpnts();
        setDisabledDeliveryTentativeDate(true);
      }

      /*if (!orderDetail.approvedInvoices && orderDetail.invoiceDate !== null) {
        enablePlatesCmpnts();
      }*/


    }
    if (!orderDetail.platesRequired && orderDetail.verificationRequired) {
      setPlatesCmpnt(true);
      setVerificationCmpnt(false);

      if (orderDetail.approvedInvoices) {
        if (orderDetail.verificationStatus === VERIFICATION_STATUS.APROBADA) {  //PR-26005 - Asalas :P2MOAC-267
          disableVerificationCmpnts();
          setDisabledDeliveryTentativeDate(false);
        }
        else {
          enableVerificationCmpnts();
          setDisabledDeliveryTentativeDate(true);
        }
      }
      else {
        disableVerificationCmpnts();
        setDisabledDeliveryTentativeDate(true);
      }
    }

    //Upload files Component
    let countFiles = 0;
    let verification = 0;
    
    if (orderDetail.approvedInvoices && orderDetail.platesRequired && orderDetail.evidences !== undefined) {
      if (orderDetail.evidences.length > 0) {
        orderDetail.evidences.forEach((item) => {
          if (item.evidenceType === "CirculationTarget") {
            setDisableCT(true);
            countFiles++;
          } else if (item.evidenceType === "rightPayment") {
            setDisableRP(true);
            countFiles++;
          } else if (item.evidenceType === "Plates") {
            setDisablePlts(true);
            countFiles++;
          }
        });
      }
      
      if (countFiles === 0){
        setDisablePltsNmbr(false);
        
      }
      else if (countFiles > 0 && countFiles < 3) {
        setDisableBtnSave(true);
        setDisablePltsNmbr(false);
        setDisableBtnUpld(false);
      }
      else if (orderDetail.platesStatus === 0 && countFiles === 3) {
        setDisableBtnSave(false);
        setDisableBtnUpld(true);
        setDisablePltsNmbr(false);
      }
      else if (orderDetail.platesStatus === 1 && countFiles === 3) {
        disablePlatesCmpnts();
        setDisableBtnSave(true);
      }
    }
    
    if (orderDetail.approvedInvoices && orderDetail.verificationRequired && orderDetail.evidences !== undefined) {
      if (orderDetail.evidences.length > 0) {
          orderDetail.evidences.forEach((item) => {   //PR-26005 - Asalas :P2MOAC-267 - P2MOAC-3004 bug fix
          if (item.evidenceType === "verificationStub") {
            verification++;

          }
        });
      }
      //PR-26005 - Asalas :P2MOAC-267 - P2MOAC-3004 bug fix
      const hasVerificationStub = verification > 0;

      // Si no existe talón de verificación, permitir cargar documento
      if (!hasVerificationStub) {
          setDisableBtnUpld(false);
          setDisablePltsNmbr(false);
      }

      if (orderDetail.platesRequired && orderDetail.platesStatus === 0 && (verification === 0 || verification !== 0)) {
        disableVerificationCmpnts();
        setDisableSendVerification(true);//PR-26005 - Asalas :P2MOAC-267

      }
      else if (orderDetail.platesRequired && orderDetail.platesStatus === 1 && verification !== 0) {
        setDisabledVerificationByApproval(false);        
        
        setDisableVr(true);
        setDisableVCD(true);
        if(verificationDate == null || verificationNextDate == null 
          || 
          !props.platesEvidence.some((x) => x.evidenceType === "verificationStub")){ //PR-26005 - Asalas :P2MOAC-267 - P2MOAC-3004 bug fix
          setDisableSendVerification(true);  //PR-26005 - Asalas :P2MOAC-267
        }
        // La habilitación del botón SendVerification la controla validateSendVerificationButton()
        

      }
      else if (!orderDetail.platesRequired && verification === 0) {
        if (orderDetail.platesStatus === 1) {
          setDisabledVerificationByApproval(false);
               
          setDisableVr(false);
          setDisableVCD(false);
          if(verificationDate == null || verificationNextDate == null 
            || 
          !props.platesEvidence.some((x) => x.evidenceType === "verificationStub")){//PR-26005 - Asalas :P2MOAC-267 - P2MOAC-3004 bug fix
          setDisableSendVerification(true);  //PR-26005 - Asalas :P2MOAC-267
          }
          // La habilitación del botón SendVerification la controla validateSendVerificationButton()
          
        }
        else {
          disableVerificationCmpnts();
          setDisableSendVerification(true);//PR-26005 - Asalas :P2MOAC-267
        }
      }
      else if (!orderDetail.platesRequired && verification !== 0) {
        setDisabledVerificationByApproval(false);
        
        setDisableVr(true);
        setDisableVCD(true);
        if(verificationDate == null || verificationNextDate == null 
          || 
          !props.platesEvidence.some((x) => x.evidenceType === "verificationStub")){//PR-26005 - Asalas :P2MOAC-267 - P2MOAC-3004 bug fix
          setDisableSendVerification(true);  //PR-26005 - Asalas :P2MOAC-267
        }
        // La habilitación del botón SendVerification la controla validateSendVerificationButton()
        
      }

      if ( !canEditVerification(orderDetail.verificationStatus) &&  verification !== 0) {  //PR-26005 - Asalas :P2MOAC-267
        disableVerificationCmpnts();
        setDisableSendVerification(true);//PR-26005 - Asalas :P2MOAC-267
        
      }

    }

    if(verificationDate == null || verificationNextDate == null 
    || 
    !props.platesEvidence.some((x) => x.evidenceType === "verificationStub")){//PR-26005 - Asalas :P2MOAC-267 - P2MOAC-3004 bug fix
        setDisableSendVerification(true);  //PR-26005 - Asalas :P2MOAC-267
      }

    if(props.orderDetail.deliveryTentativeDateStatus === 1)
    {
      setDisabledDeliveryTentativeDate(true)
    }
    
    //P2MSPFE-4420
    const canEditByStage = stageId >= 1 && stageId <= 6;
    const hasAnnexB = props.orderDetail.annexB !== null;

    let disableDt = true;
    let disableDtBtn = true;
    let disabledAnnexButton = true;

    if (props.orderDetail.deliveryTentativeDateStatus === 0) {
      setDisableDt(true);
      setDisableDtBtn(true);
      setDisabledAnnexButton(true);
    } else {
      if (canEditByStage && !hasAnnexB) {
        disabledAnnexButton = false;

        if (props.orderDetail.deliveryDate != null) {
          disableDt = true;
        } else {
          disableDt = false;
        }
      }
    }
    if (hasAnnexB && props.orderDetail.deliveryDate == null) {
      disableDt = false;
      disableDtBtn = false;
    }

    setDisableDt(disableDt);
    setDisableDtBtn(disableDtBtn);
    setDisabledAnnexButton(disabledAnnexButton);

    
   
  }


  const enablePlatesCmpnts = () => {
    //enable Plates Grid
    setDisabledPlatesByApproval(false);
    setDisableCT(false);
    setDisableRP(false);
    setDisablePlts(false);
    setDisablePltsNmbr(false);
    setDisableBtnUpld(false);
  }

  const disablePlatesCmpnts = () => {
    //disable Plate Grid
    setDisabledPlatesByApproval(true);
    setDisableCT(true);
    setDisableRP(true);
    setDisablePlts(true);
    setDisablePltsNmbr(true);
    setDisableBtnUpld(true);
  }

  const enableVerificationCmpnts = () => {
    //enable Verification Grid
    setDisabledVerificationByApproval(false);
    
    setDisableVr(false);
    setDisableVCD(false);
  }

  const disableVerificationCmpnts = () => {
    //disable Verification Grid
    setDisabledVerificationByApproval(true);
    
    setDisableVr(true);
    setDisableVCD(true);
  }

  const updateNotif = () => {
    if (props.notifications) {
      for (let i = 0; i < props.notifications.length; i++) {
        if (props.notifications.supplierNotifReadInd === 1) {
          props.notificationActions.fetch_NotificationChngStatus(
            props.userLanguage,
            props.userToken,
            props.notifications.purchaseOrderId,
            props.notifications.idNvpQuoteUnits,
            0,
            "",
            onError,
            handleClose
          );
        }
      }
    }
  };
  const handleClose = () => {
    setOpenLoading(false);
  };

  const result = (response) => {
    gridValidations(response,stageId);
    validateSendVerificationButton(response);    //PR-26005 - Asalas :P2MOAC-267 - P2MOAC-3004 bug fix
  };
  const handleOpen = () => {
    setOpenLoading(true);
  };

  const onError = (err) => {
    handleClose();
    if (err.response && err.response.status) {
      switch (err.response.status) {
        case 400:
          var plateNumber =
            err.response.data.errors.PlateNumber &&
            err.response.data.errors.PlateNumber[0];

          toast.error(plateNumber, { className: classes.toastError });

          break;
        case 401:
          props.tokenExpired();
          history.push("/login");
          break;
        case 403:
          history.push("/forbidden");
          break;
        case 500:
          toast.error("Ha ocurrido un error", {
            className: classes.toastError,
          });
          break;
        default:
          break;
      }
    }
  };

  const onSuccess = () => {
    handleClose();
    props.purchaseActions.fetch_order_detail(
      props.userLanguage,
      props.userToken,
      params.orderId,
      onError,
      handleClose
    );
    toast.success("Se guardaron cambios", { className: classes.toastSuccess });
  };

  //PR-26005 - Asalas :P2MOAC-267
  const onSuccessMensaje = (mensaje) => {
    handleClose();
    props.purchaseActions.fetch_order_detail(
      props.userLanguage,
      props.userToken,
      params.orderId,
      onError,
      handleClose
    );
    toast.success(mensaje, { className: classes.toastSuccess });
  };

  const onSuccessPlates = (response) => {
    handleClose();
    Array.from(document.querySelectorAll("input")).forEach(
      (input) => (input.value = "")
    );
    props.purchaseActions.fetch_order_detail(
      props.userLanguage,
      props.userToken,
      params.orderId,
      onError,
      handleClose
    );
    CleanInputs();
    if(response.platesComment == "Número de placa ya existe")
      toast.error(response.platesComment, { className: classes.toastError});
    else
      handleplatesRequiredSubmit();//PR-24005 - ASALAS bugfix P2MSPFE-667
      //toast.success("Se guardaron cambios", { className: classes.toastSuccess });
  };

  //P2MSPFE-4420
  const onSuccessStageId = (response) => {
    if (response !== undefined) {
      setStageId(response.stageId);
    }
  };

  const onErrorStageId = (err) => {
    if (err.response && err.response.status) {
      switch (err.response.status) {
        case 401:
          props.tokenExpired();
          history.push("/login");
          break;
        case 403:
          history.push("/forbidden");
          break;
        case 500:
          toast.error("Ha ocurrido un error", {
            className: classes.toastError,
          });
          break;
        default:
          break;
      }
    }
  };
  //End P2MSPFE-4420

  const onChangeHandler = (event, option) => {
    let optioneInt;
    if (option === "vefirication") {
      optioneInt = checkFileTypeVerification(event);
    } else {
      optioneInt = checkFileType(event);
    }

    if (optioneInt) {
      switch (option) {
        case "rightPayment":
          setRightPaymentFile(event.target.files[0]);
          break;
        case "circulationTarget":
          setCirculationTargetFile(event.target.files[0]);
          break;
        case "plates":
          setPlatesFile(event.target.files[0]);
          break;
        case "vefirication":
          setVerificationFile(event.target.files[0]);
          break;
        default:
          break;
      }
    } else {
      switch (option) {
        case "rightPayment":
          setRightPaymentFile(null);
          break;
        case "circulationTarget":
          setCirculationTargetFile(null);
          break;
        case "plates":
          setPlatesFile(null);
          break;
        case "vefirication":
          setVerificationFile(null);
          break;
        default:
          break;
      }
      return false;
    }
  };

  const onChangePlateNumberHandler = (e) => {
    setPlateNumber(e.target.value);
  };

  const checkFileType = (event) => {
    let file = event.target.files[0];
    if (file != null) {
      let types = [
        "image/jpeg",
        "image/jpg",
        "application/pdf",
        "image/png",
        "image/svg+xml",
        "application/msword",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      ];
      if (types.every((type) => file.type !== type)) {
        toast.error(file.type + " Formato no soportado", {
          className: classes.toastError,
        });
        event.target.value = null;
        return false;
      } else {
        return true;
      }
    }
  };

  const checkFileTypeVerification = (event) => {
    let file = event.target.files[0];
    if (file != null) {
      let types = ["image/jpeg", "image/jpg", "image/png", "application/pdf"];
      if (types.every((type) => file.type !== type)) {
        toast.error(file.type + " Formato no soportado", {
          className: classes.toastError,
        });
        event.target.value = null;
        return false;
      } else {
        return true;
      }
    }
  };

  const handlePlatesUpload = () => {
    let isRightPayment = false,
      isCirculationTarget = false,
      isPlates = false; // eslint-disable-next-line
    props.platesEvidence
      .filter((x) => x.evidenceType !== "verificationStub")
      .map((item, index) => {
        switch (item.evidenceType) {
          case "rightPayment":
            isRightPayment = true;
            break;
          case "CirculationTarget":
            isCirculationTarget = true;
            break;
          case "Plates":
            isPlates = true;
            break;
          default:
            break;
        }
      });
    //PR-24005 - ASALAS bugfix P2MSPFE-667
    if (platesDate === null) {
      Modal.error({
        title: "Error",
        content: "Debe capturar la fecha de emplacado",
      });
      return;
    }
    if (platesDate < invoiceDate) {
      Modal.error({
        title: "Error",
        content:
          "La fecha de emplacado no puede ser inferior a la fecha de la factura",
      });
      return;
    }

    let dateP = platesDate._d.getDate();
    let monthP = platesDate._d.getMonth() + 1;
    let yearP = platesDate._d.getFullYear();
    let platesDateShort = `${yearP}${"-"}${monthP < 10 ? `0${monthP}` : `${monthP}`
      }${"-"}${dateP < 10 ? `0${dateP}` : `${dateP}`}`;

    if (platesDateShort > actualDate) {
      Modal.error({
        title: "Error",
        content: "La fecha de emplacado no puede ser mayor a la fecha actual",
      });
      return;
    }
    
    if (
      isRightPayment &&
      isCirculationTarget &&
      isPlates &&
      props.orderDetail.plateNumber !== "" &&
      plateNumber === ""
    ) {
      toast.info("Los archivos ya han sido cargados");
      return;
    }
    if (
      isRightPayment === false &&
      rightPaymentFile === null &&
      isCirculationTarget === false &&
      circulationTargetFile === null &&
      isPlates === false &&
      platesFile === null
    ) {
      toast.error("No se seleccionó ningún archivo", {
        className: classes.toastError,
      });
      return;
    }

    if (isRightPayment === false && rightPaymentFile === null) {
      toast.error("No se seleccionó ningún archivo para Pago de derecho", {
        className: classes.toastError,
      });
      return;
    }

    if (isCirculationTarget === false && circulationTargetFile === null) {
      toast.error(
        "No se seleccionó ningún archivo para Tarjeta de circulación",
        {
          className: classes.toastError,
        }
      );
      return;
    }

    if (isPlates === false && platesFile === null) {
      toast.error("No se seleccionó ningún archivo para Placas", {
        className: classes.toastError,
      });
      return;
    }

    if (props.orderDetail.plateNumber === null) {
      if (plateNumber === "") {
        toast.error("El número de placas no puede estar vacío", {
          className: classes.toastError,
        });
        return;
      }
    }
    handleOpen();
    
    const formData = new FormData();
    formData.append("OrderId", params.orderId);
    formData.append("RightPaymentFile", rightPaymentFile);
    formData.append("CirculationTargetFile", circulationTargetFile);
    formData.append("PlatesFile", platesFile);
    formData.append("PlateNumber", plateNumber);
    props.purchaseActions.upload_evidence(
      props.userLanguage,
      props.userToken,
      params.orderId,
      formData,
      onError,
      onSuccessPlates
    );
    
  };

  const handleVerificationUpload = () => {
    if (verificationFile != null) {
      handleOpen();
      const formData = new FormData();
      formData.append("OrderId", params.orderId);
      formData.append("VerificationFileFile", verificationFile);
      props.purchaseActions.upload_evidence(
        props.userLanguage,
        props.userToken,
        params.orderId,
        formData,
        onError,
        onSuccess
      );
      Array.from(document.querySelectorAll("input")).forEach(
        (input) => (input.value = "")
      );
      CleanInputs();
    } else {
      toast.error("No seleccionó un archivo", {
        className: classes.toastError,
      });
    }
  };

  const handleDownload = (documentId) => {
    handleOpen();
    props.purchaseActions.download_evidence(
      "es-MX",
      props.userToken,
      onError,
      documentId,
      params.orderId,
      onSuccessDownload
    );
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
    Array.from(document.querySelectorAll("input")).forEach(
      (input) => (input.value = "")
    );
    CleanInputs();

    if (newValue === 5) {
      updateNotif();
    }
  };

  const CleanInputs = () => {
    setRightPaymentFile(null);
    setCirculationTargetFile(null);
    setPlatesFile(null);
    setVerificationFile(null);
    setAnnexbFile(null);
    setPlateNumber("");
  };

  const handleHourChange = (time, timeString) => {
    if (timeString !== "") setHour(timeString);
    else setHour(null);
  };

  const handleTentativeDeliveryDate = (e) => {
    if (e != null) {
      setDeliveryTentativeDate(moment(e.format("YYYY-MM-DD"), "YYYY-MM-DD"));
    } else {
      setDeliveryTentativeDate(null);
    }
  };

  const handleRealDeliveryDate = (e) => {
    if (e != null)
      setDeliveryDate(moment(e.format("YYYY-MM-DD"), "YYYY-MM-DD"));
    else setDeliveryDate(null);
  };

  const handlePlatesDate = (e) => {
    if (e != null) setPlatesDate(moment(e.format("YYYY-MM-DD"), "YYYY-MM-DD"));
    else setPlatesDate(null);
  };
  
  //PR-26005 - Asalas :P2MOAC-267 -P2MOAC-2651
  const handleVerificationDate = (e) => {
    if (!e) {
      setVerificationDate(null);
      setVerificationNextDate(null);

      setDisabledVerificationNextDate(true);   
      setDisableSendVerification(true);
      return;
    }

    const newDate = moment(e.format("YYYY-MM-DD"), "YYYY-MM-DD");

    setVerificationDate(newDate);

    const hasStub = props.platesEvidence?.some(
      (x) => x.evidenceType === "verificationStub"
    );

    const next = verificationNextDate;

    const isValidNext =
      next && moment(newDate).endOf("day") < moment(next).endOf("day");

    if (!isValidNext) {
      setVerificationNextDate(null);
    }

    
    
    setDisableSendVerification(!(hasStub && next));
  };

  
  //PR-26005 - Asalas :P2MOAC-267 -P2MOAC-2651
  const handleVerificationNextDate = (e) => {
    if (!e) {
      setVerificationNextDate(null);
      setDisableSendVerification(true);
      return;
    }

    const newNext = moment(e.format("YYYY-MM-DD"), "YYYY-MM-DD");

    setVerificationNextDate(newNext);
    

    const hasStub = props.platesEvidence?.some(
      (x) => x.evidenceType === "verificationStub"
    );

    setDisableSendVerification(!(verificationDate && hasStub));
  };

  

  function disabledDate(current) {
    return current && current <= moment(verificationDate).endOf('day');
  }

  //PR-24005 - ASALAS bugfix P2MSPFE-667
  const handleplatesRequiredSubmit = () => {
    
    const deliveryDates = {
      plates: platesDate,
    };
    props.purchaseActions.save_delivery_dates(
      props.userLanguage,
      props.userToken,
      params.orderId,
      deliveryDates,
      onError,
      onSuccess
    );
    
  };

  //PR-26005 - Asalas :P2MOAC-267
  const handleSaveVerificationRequiredSubmit = () => {
    handleOpen();

    const hasVerificationDates =   verificationDate !== null ;

    if (!hasVerificationDates) {
        onSuccess();
        handleClose();
        return;
    }
    
    const deliveryDates = {
      verification: verificationDate !== null? verificationDate.format("YYYY-MM-DD") : null,
      verificationNext : verificationNextDate !== null? verificationNextDate.format("YYYY-MM-DD") : null
    };
    props.purchaseActions.saveOnSupplierPortal_delivery_dates(
      props.userLanguage,
      props.userToken,
      params.orderId,
      deliveryDates,
      onError,
      () => onSuccessMensaje("Se realizo el guardado exitosamente. No enviado a Element")  //PR-26005 - Asalas :P2MOAC-267-P2MOAC-2650
    );
  };

  const handleSentVerificationRequiredSubmit = () => {
    handleOpen();
    if (platesDate === null && props.orderDetail.platesRequired) {
      Modal.error({
        title: "Error",
        content: "Debe capturar una fecha de emplacado",
      });
      handleClose();
      return;
    }
    if (verificationDate === null) {
      Modal.error({
        title: "Error",
        content: "Debe capturar una fecha",
      });
      handleClose();
      return;
    }
    if (verificationDate < platesDate) {
      Modal.error({
        title: "Error",
        content:
          "La fecha de verificación debe ser posterior a la de emplacado",
      });
      handleClose();
      return;
    }
    if (verificationDate < invoiceDate) {
      Modal.error({
        title: "Error",
        content:
          "La fecha de verificación debe ser posterior a la fecha de la factura",
      });
      handleClose();
      return;
    }
    let dateV = verificationDate._d.getDate();
    let monthV = verificationDate._d.getMonth() + 1;
    let yearV = verificationDate._d.getFullYear();
    let verificationDateShort = `${yearV}${"-"}${monthV < 10 ? `0${monthV}` : `${monthV}`
      }${"-"}${dateV < 10 ? `0${dateV}` : `${dateV}`}`;

    if (verificationDateShort > actualDate) {
      Modal.error({
        title: "Error",
        content:
          "La fecha de verificación no puede ser mayor a la fecha actual",
      });
      handleClose();
      return;
    }
    const deliveryDates = {
      verification: verificationDate.format("YYYY-MM-DD"),
      verificationNext : verificationNextDate.format("YYYY-MM-DD")
    };
    //PR-26005 - Asalas :P2MOAC-267
    props.purchaseActions.save_delivery_dates(
      props.userLanguage,
      props.userToken,
      params.orderId,
      deliveryDates,
      onError,
      onSuccessMensaje("Se realizo el envío exitosamente")
    );
  };

  const handleTentativeDeliveryDateSubmit = () => {
    /* Delivery tentaive date - Fecha tentativa de entrega*/
    if (props.orderDetail.verificationRequired && !verificationDate) {
      Modal.error({
        title: "Error",
        content: "Debe capturar una fecha de verificación",
      });
      return;
    }
    if (props.orderDetail.platesRequired && !platesDate) {
      Modal.error({
        title: "Error",
        content: "Debe capturar una fecha de emplacado",
      });
      return;
    }
    if (deliveryTentativeDate === null) {
      Modal.error({
        title: "Error",
        content: "Debe capturar una fecha de entrega programada",
      });
      return;
    }

    if (
      !props.orderDetail.platesRequired &&
      !props.orderDetail.verificationRequired &&
      deliveryDate < props.orderDetail.nvpAcceptanceDate
    ) {
      Modal.error({
        title: "Error",
        content:
          "La Fecha de entrega programada debe ser mayor a la fecha de la factura de la unidad",
      });
      return;
    }

    let dateD = deliveryTentativeDate._d.getDate();
    let monthD = deliveryTentativeDate._d.getMonth() + 1;
    let yearD = deliveryTentativeDate._d.getFullYear();
    let deliveryTentativeDateShort = `${yearD}${"-"}${monthD < 10 ? `0${monthD}` : `${monthD}`
      }${"-"}${dateD < 10 ? `0${dateD}` : `${dateD}`}`;

    var date1 = parseISO(deliveryTentativeDateShort);
    var date2 = parseISO(actualDate);
    const compDate = compareAsc(date1, date2);
    if (compDate === -1) {
      Modal.error({
        title: "Error",
        content:
          "La Fecha de entrega programada debe ser mayor o igual a la fecha actual",
      });
      return;
    }
    const deliveryDates = {
      tentativeDelivery: deliveryTentativeDate,
    };
    props.purchaseActions.save_delivery_dates(
      props.userLanguage,
      props.userToken,
      params.orderId,
      deliveryDates,
      onError,
      onSuccess
    );
  };

  const handleDeliveryDate = () => {
    /* Actual delivery date with hour - Fecha real de entrega con hora*/
    if (
      deliveryTentativeDate &&
      deliveryDate !== null &&
      (hour === null || hour === "")
    ) {
      Modal.error({
        title: "Error",
        content: "Debe capturar la hora de entrega",
      });
      return;
    }
    if (deliveryDate !== null && (hour === null || hour === "")) {
      Modal.error({
        title: "Error",
        content: "Debe capturar la hora de entrega",
      });
      return;
    }
    if (hour === null) {
      Modal.error({
        title: "Error",
        content: "Debe capturar la hora de entrega",
      });
      return;
    }
    if (hour === "") {
      Modal.error({
        title: "Error",
        content: "Debe capturar la hora de entrega",
      });
      return;
    } else if (deliveryDate === null) {
      Modal.error({
        title: "Error",
        content: "Debe capturar una fecha de entrega",
      });
      return;
    }
    if (
      !props.orderDetail.platesRequired &&
      !props.orderDetail.verificationRequired &&
      deliveryDate < props.orderDetail.nvpAcceptanceDate
    ) {
      Modal.error({
        title: "Error",
        content:
          "La Fecha de entrega debe ser mayor a la fecha de la factura de la unidad",
      });
      return;
    }
    if (deliveryTentativeDate === null) {
      Modal.error({
        title: "Error",
        content: "Debe capturar una fecha de entrega programada",
      });
      return;
    }
    if (!props.orderDetail.annexB) {
      Modal.error({
        title: "Error",
        content: "Debe cargar el Anexo B",
      });
      return;
    }
    if (deliveryDate < verificationDate) {
      Modal.error({
        title: "Error",
        content:
          "La Fecha real de entrega debe de ser mayor a la fecha de verificación",
      });
      return;
    }

    let dateDe = deliveryDate._d.getDate();
    let monthDe = deliveryDate._d.getMonth() + 1;
    let yearDe = deliveryDate._d.getFullYear();
    let deliveryDateShort = `${yearDe}${"-"}${monthDe < 10 ? `0${monthDe}` : `${monthDe}`
      }${"-"}${dateDe < 10 ? `0${dateDe}` : `${dateDe}`}`;

    if (deliveryDateShort > actualDate) {
      Modal.error({
        title: "Error",
        content: "La Fecha real de entrega no debe ser mayor a la fecha actual",
      });
      return;
    }
    setOpenDialog(true);
  };

  const handleDeliveryDateSubmit = () => {
    const deliveryDates = {
      delivery: deliveryDate,
      deliveryHour: hour,
    };
    props.purchaseActions.save_delivery_dates(
      props.userLanguage,
      props.userToken,
      params.orderId,
      deliveryDates,
      onError,
      onSuccess
    );
    setOpenDialog(false);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const handleDownloadOrderDetails = () => {
    handleOpen();
    props.purchaseActions.download_order_details(
      props.userLanguage,
      props.userToken,
      params.orderId,
      onError,
      onSuccessDownload
    );
  };

  const handleDownloadFileAnexoB = () => {
    handleOpen();
    props.purchaseActions.download_document_AnnexB(
      props.userLanguage,
      props.userToken,
      props.orderDetail.nvpQuoteMultipleunits,
      params.orderId,
      onErrorDownload,
      onSuccessDownload
    );
  };

  const onSuccessDownload = (response) => {
    handleClose();
    toast.success("Se completó la descarga correctamente", {
      className: classes.toastSuccess,
    });
  };

  const handleDelete = (documentId, nameInContainer) => {
    handleOpen();
    props.purchaseActions.delete_evidence(
      "es-MX",
      props.userToken,
      documentId,
      params.orderId,
      nameInContainer,
      onError,
      onSuccess
    );

    
  };

  const onErrorDownload = (err) => {
    handleClose();
    if (err.response && err.response.status) {
      switch (err.response.status) {
        case 400:
          toast.info("Anexo B no disponible");
          break;
        case 401:
          props.tokenExpired();
          history.push("/login");
          break;
        case 403:
          history.push("/forbidden");
          break;
        case 500:
          toast.info("Anexo B no disponible");
          break;
        default:
          break;
      }
    }
  };

  const checkFileTypeAnnexB = (event) => {
    let file = event.target.files[0];
    if (file != null) {
      let types = ["image/jpeg", "image/jpg", "application/pdf", "image/png"];
      if (types.every((type) => file.type !== type)) {
        toast.error(file.type + " Formato no soportado", {
          className: classes.toastError,
        });
        event.target.value = null;
        return false;
      } else {
        return true;
      }
    }
  };

  const onChangeHandlerAnnexB = (event) => {
    if (checkFileTypeAnnexB(event)) {
      setAnnexbFile(event.target.files[0]);
    } else {
      setAnnexbFile(null);
    }
  };

  const onSuccessAnnexB = () => {
    handleClose();
    Array.from(document.querySelectorAll("input")).forEach(
      (input) => (input.value = "")
    );
    CleanInputs();
    toast.success("Se cargó correctamente el archivo", {
      className: classes.toastSuccess,
    });
  };

  const handleAnnexbSubmit = () => {
    if (annexbFile !== null) {
      handleOpen();
      const formData = new FormData();
      formData.append("OrderId", parseInt(params.orderId));
      formData.append("AnnexbFile", annexbFile);
      props.purchaseActions.upload_annexB(
        props.userLanguage,
        props.userToken,
        params.orderId,
        formData,
        onError,
        onSuccessAnnexB
      );

    } else {
      toast.error("No seleccionó un archivo", {
        className: classes.toastError,
      });
    }
  };

  const getRowClassName = (statusNotif) => {
    if (statusNotif === 1) return "flagged-row";
  };

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
      width: "33%",
    },
  }));

  const StyledTableRow = styled(TableRow)(({ theme }) => ({}));
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  //PR-26005 - Asalas :P2MOAC-267
  const readOnlyVerification =
        !canEditVerification(
            props.orderDetail.verificationStatus
        );

  return (
    <div>
      <TopBarNav />
      <br />
      <BreadcrumbsHistory />
      <br />
      <Container maxWidth="xl" className={classes.root}>
        <Backdrop className={classes.backdrop} open={loading}>
          <CircularProgress color="inherit" />
        </Backdrop>
        <Grid container item xs={12} spacing={3}>
          <Grid item xs={12} className={classes.alignCenter}>
            <h5>Detalle de la orden</h5>
          </Grid>
          <Grid item xs={12} className={classes.alignCenter}>
            <h4>
              Número OC: {props.orderDetail.consecutiveIndex ? `${props.orderDetail.fleet}/${props.orderDetail.unit} - ${props.orderDetail.consecutiveIndex }`: `${props.orderDetail.fleet}/${props.orderDetail.unit}`}
            </h4>
            <h5>Folio cotización: {props.orderDetail.quote}</h5>
            <h6>
              Fecha orden de compra:{" "}
              {orderDate && orderDate.format("MM-DD-YYYY")} / Fecha de factura:{" "}
              {invoiceDate
                ? invoiceDate.format("MM-DD-YYYY")
                : "Pendiente de carga de factura"}
            </h6>
          </Grid>
        </Grid>
        <Container maxWidth="lg">
          <Grid
            container
            item
            xs={12}
            spacing={3}
            className={classes.containerWithBorder}
          >
            <Tabs
              value={value}
              onChange={handleChange}
              indicatorColor="primary"
              textColor="primary"
              variant="scrollable"
              className={classes.tabsHorizontal}
            >
              <Tab label="General" />
              <Tab label="Información del cliente" />
              {showtabs && <Tab label="Subir Documentos" />}
              {showtabs && <Tab label="Fechas" onClick={fecthDataForTab} hidden ={isOCA}/>}
              {showtabs && <Tab label="Anexo B" hidden = {isOCA}/>}
              {showtabs && (
                <Tab
                  icon={
                    <Badge
                      color="secondary"
                      variant="dot"
                      invisible={!invisible}
                    >
                      Notificaciones
                    </Badge>
                  }
                ></Tab>
              )}
            </Tabs>

            <TabPanel value={value} index={0}>
              <PurchaseOrderDetailGeneral orderDetail={props.orderDetail} />
            </TabPanel>
            <TabPanel value={value} index={1}>
              <PurchaseOrderDetailClientInformation
                              orderDetail={props.orderDetail}
                              isInvoice={isInvoice}
              />
            </TabPanel>
            {showtabs && (
              <TabPanel value={value} index={2}>
                <PurchaseUploadInvoice orderId={params.orderId} />
              </TabPanel>
            )}
            { !isOCA && showtabs && (
              <TabPanel value={value} index={3}>
                <Grid container className={classes.containerWithBorderRound} hidden={platesCmpnt}>
                  {props.orderDetail.platesRequired && (
                    <Grid>
                      <Grid item xs={12} className={classes.gridColor1}>
                        <h5 className={classes.textColorWhite}>Emplacado</h5>
                      </Grid>
                      {
                        <Grid item xs={12}>
                          {props.orderDetail.platesStatus === 2 && (
                            <p className={classes.rejectedComment}>
                              {props.orderDetail.platesComment}
                            </p>
                          )}
                        </Grid>
                      }
                      <Grid container item xs={12} spacing={3}>
                        <Grid item xs={12}>
                          <WhiteSpace size="lg" />
                        </Grid>
                        <Grid item xs={4} className={classes.alignRight}>
                          <h5>¿Requiere placas?</h5>
                        </Grid>
                        <Grid item xs={4} className={classes.alignCenter}>
                          <h5>
                            {props.orderDetail.platesRequired ? "Si" : "No"}
                          </h5>
                        </Grid>
                        <Grid item xs={4} className={classes.alignCenter}>
                          <h5>&nbsp;</h5>
                        </Grid>
                      </Grid>
                      <Grid container item xs={12} spacing={3}>
                        <Grid item xs={4} className={classes.alignRight}>
                          <h5>Fecha de emplacado</h5>
                        </Grid>
                        <Grid item xs={4} className={classes.alignCenter}>
                          <DatePicker
                            placeholder="Seleccione Fecha"
                            className={
                              disabledPlatesByApproval ? "" : "classname"
                            }
                            disabled={disabledPlatesByApproval}
                            onChange={handlePlatesDate}
                            defaultValue={platesDate}
                          />
                        </Grid>
                      </Grid>
                      <Grid container item xs={12} spacing={3}>
                        <Grid item xs={12}>
                          <WhiteSpace size="lg" />
                        </Grid>
                        <Grid container item xs={12}>
                          <Grid item xs={4} className={classes.alignRight}>
                            <h5>Pago de derecho&nbsp;&nbsp;</h5>
                          </Grid>
                          <Grid item xs={4}>
                            <FormControl>
                              <Input
                                type="file"
                                name="rightPayment"
                                id="rightPayment"
                                disabled={disableRP}
                                /*disabled={
                                  disabledRightPayment ||
                                  disabledPlatesByApproval
                                    ? true
                                    : false
                                }*/
                                onChange={(e) =>
                                  
                                  onChangeHandler(e, "rightPayment")
                                }
                                startAdornment={
                                  <InputAdornment position="start">
                                    <InboxIcon />
                                  </InputAdornment>
                                }
                              />
                            </FormControl>
                          </Grid>
                        </Grid>
                        <Grid container item xs={12}>
                          <Grid item xs={4} className={classes.alignRight}>
                            <h5>Tarjeta de circulación &nbsp;&nbsp;</h5>
                          </Grid>
                          <Grid item xs={4}>
                            <FormControl>
                              <Input
                                type="file"
                                name="circulationTarget"
                                id="circulationTarget"
                                disabled={disableCT}
                                /*disabled={
                                  disabledCirculationTarget ||
                                  disabledPlatesByApproval
                                    ? true
                                    : false
                                }*/
                                onChange={(e) =>
                                  onChangeHandler(e, "circulationTarget")
                                }
                                startAdornment={
                                  <InputAdornment position="start">
                                    <InboxIcon />
                                  </InputAdornment>
                                }
                              />
                            </FormControl>
                          </Grid>
                        </Grid>
                        <Grid container item xs={12}>
                          <Grid item xs={4} className={classes.alignRight}>
                            <h5>Placas &nbsp;&nbsp;</h5>
                          </Grid>
                          <Grid item xs={4}>
                            <FormControl>
                              <Input
                                type="file"
                                name="plates"
                                id="plates"
                                disabled={disablePlts}
                                /* disabled={
                                  disabledPlates || disabledPlatesByApproval
                                    ? true
                                    : false
                                }*/
                                onChange={(e) => onChangeHandler(e, "plates")}
                                startAdornment={
                                  <InputAdornment position="start">
                                    <InboxIcon />
                                  </InputAdornment>
                                }
                              />
                            </FormControl>
                          </Grid>
                        </Grid>
                        <Grid container item xs={12}>
                          <Grid item xs={4} className={classes.alignRight}>
                            <h5>Número de placas &nbsp;&nbsp;</h5>
                          </Grid>
                          <Grid item xs={4}>
                            <FormControl>
                              <Input
                                type="text"
                                onChange={(e) => onChangePlateNumberHandler(e)}
                                // disabled={disabledPlatesByApproval}
                                disabled={disablePltsNmbr}
                                startAdornment={
                                  <InputAdornment position="start">
                                    <InboxIcon />
                                  </InputAdornment>
                                }
                              />
                            </FormControl>
                          </Grid>
                          {props.orderDetail.plateNumber && (
                            <Grid item xs={4}>
                              <h5>{props.orderDetail.plateNumber}</h5>
                            </Grid>
                          )}
                        </Grid>
                        <Grid container item xs={12}>
                          <Grid item xs={8} className={classes.alignRight}>
                            <Button
                              size="small"
                              onClick={handlePlatesUpload}
                              variant="contained"
                              disabled={disableBtnUpld}
                              //disabled={disabledPlatesByApproval}
                              color="primary"
                            >
                              Cargar y Enviar Información
                            </Button>
                          </Grid>
                          {/*PR-24005 - ASALAS bugfix P2MSPFE-667*/}
                          {/* {props.orderDetail.platesRequired && (
                            <Grid item xs={4} className={classes.saveButtons}>
                              <Button
                                size="small"
                                //disabled={disabledPlatesByApproval}
                                disabled={disableBtnSave}
                                onClick={handleplatesRequiredSubmit}
                                variant="contained"
                                color="primary"
                              >
                                Guardar emplacado
                              </Button>
                            </Grid>
                          )} */}
                        </Grid>

                        <Grid item xs={2} className={classes.alignRight}>
                          <b>Lista de documentos:</b>
                        </Grid>
                        <Container
                          maxWidth="lg"
                          className={classes.alignCenter}
                        >
                          <Grid item xs={10}>
                            <DataTable
                              columns={getUploadPurchaseEvidenceTableColumns(
                                props.orderDetail.platesStatus === 1
                                  ? true
                                  : false,
                                "PurchaseEvidence",
                                { handleDownload, handleDelete }
                              )}
                              data={props.platesEvidence.filter(
                                (x) => x.evidenceType !== "verificationStub"
                              )}
                              defaultSortField=""
                              noHeader={true}
                              dense
                              highlightOnHover
                              pointerOnHover
                              pagination
                              paginationComponentOptions={paginationOptions}
                              noDataComponent={
                                <p className={classes.marginNoData}>
                                  {t("commonMessages.noData")}
                                </p>
                              }
                            />
                          </Grid>
                        </Container>
                        <Grid item xs={12}>
                          <WhiteSpace size="lg" />
                        </Grid>
                      </Grid>
                    </Grid>
                  )}
                </Grid>
                <Grid container className={classes.containerWithBorderRound} hidden={verificationCmpnt}>
                  {props.orderDetail.verificationRequired && (
                    <Grid>
                      <Grid item xs={12} className={classes.gridColor1}>
                        <h5 className={classes.textColorWhite}>Verificación</h5>
                      </Grid>
                      {props.orderDetail.verificationStatus  === VERIFICATION_STATUS.RECHAZADA && (
                        <p className={classes.rejectedComment}>
                          {props.orderDetail.verificationComment}
                        </p>
                      )}
                      <Grid container item xs={12} spacing={3}>
                        <Grid item xs={12}>
                          <WhiteSpace size="lg" />
                        </Grid>
                        <Grid item xs={4} className={classes.alignRight}>
                          <h5>¿Requiere verificación?</h5>
                        </Grid>
                        <Grid item xs={4} className={classes.alignCenter}>
                          <h5>
                            {props.orderDetail.verificationRequired
                              ? "Si"
                              : "No"}
                          </h5>
                        </Grid>
                        <Grid item xs={4} className={classes.alignCenter}>
                          <h5>&nbsp;</h5>
                        </Grid>
                      </Grid>
                      <Grid container item xs={12} spacing={3}>
                        <Grid item xs={4} className={classes.alignRight}>
                          <h5>Fecha de Verificación</h5>
                        </Grid>
                        <Grid item xs={2} className={classes.alignCenter}>
                          <DatePicker
                            placeholder="Seleccione Fecha"
                            className={
                              disabledVerificationByApproval ? "" : "classname"
                            }
                            disabled={disabledVerificationByApproval}
                            onChange={handleVerificationDate}
                            value={verificationDate}
                          />
                        </Grid>
                        <Grid item xs={3} className={classes.alignRight}>
                          <h5>Fecha Siguiente Verificación</h5>
                        </Grid>
                        <Grid item xs={3} className={classes.alignLeft}>
                          <DatePicker
                            placeholder="Seleccione Fecha"
                            className={
                              disabledVerificationNextDate ? "" : "classname"
                            }
                            disabled={disabledVerificationNextDate}
                            disabledDate={disabledDate}
                            onChange={handleVerificationNextDate}
                            value={verificationNextDate}
                          />
                          <Tooltip
                            title="Ingresar la fecha de la próxima verificación que se encuentra en el Talón."
                            arrow
                            classes = {{ tooltip: classes.tooltip, arrow: classes.arrow}}
                            >
                              <span>
                              <HelpOutlineIcon fontSize="small" className={classes.helpIcon} />
                              </span>               
                          </Tooltip>                      
                        </Grid>
                      </Grid>
                      <Grid container item xs={12} spacing={3}>
                        <Grid item xs={12}>
                          <WhiteSpace size="lg" />
                        </Grid>
                        <Grid container item xs={12}>
                          <Grid item xs={4} className={classes.alignRight}>
                            <h5>Talón de verificación &nbsp;&nbsp;</h5>
                          </Grid>
                          <Grid item xs={4}>
                            <FormControl>
                              <Input
                                type="file"
                                name="vefirication"
                                id="vefirication"
                                disabled={disableVr}
                                onChange={(e) =>
                                  onChangeHandler(e, "vefirication")
                                }
                                startAdornment={
                                  <InputAdornment position="start">
                                    <InboxIcon />
                                  </InputAdornment>
                                }
                              />
                            </FormControl>
                          </Grid>
                        </Grid>
                        {/* //PR-26005 - Asalas :P2MOAC-267 */}
                        <Grid container item xs={12} className={classes.buttonsContainer}>
                          <Grid className={classes.alignRight}>
                            <Button
                              size="small"
                              onClick={handleVerificationUpload}
                              variant="contained"
                              color="primary"
                              disabled={disableVCD}
                            >
                              Cargar documento
                            </Button>
                          </Grid>
                          {props.orderDetail.verificationRequired && (
                            <>
                            <Grid  className={classes.saveButtons}>
                              <Button
                                size="small"
                                onClick={handleSaveVerificationRequiredSubmit}
                                variant="contained"
                                color="primary"
                                disabled={isSaveDisabled}
                              >
                                Guardar verificación
                              </Button>
                            </Grid>      
                            <Grid  className={classes.saveButtons}>
                              <Button
                                size="small"
                                onClick={handleSentVerificationRequiredSubmit}
                                variant="contained"
                                color="primary"
                                disabled={disableSendVerification}                              
                              >
                                Enviar verificación
                              </Button>
                            </Grid>
                            </>
                          )}
                        </Grid>

                        <Grid item xs={2} className={classes.alignRight}>
                          <b>Lista de documentos:</b>
                        </Grid>
                        <Container
                          maxWidth="lg"
                          className={classes.alignCenter}
                        >
                          {/* //PR-26005 - Asalas :P2MOAC-267 */}
                          <Grid item xs={10}>
                            <DataTable
                              columns={getUploadPurchaseEvidenceTableColumns(
                                readOnlyVerification,
                                "PurchaseEvidence",
                                { handleDownload, handleDelete }
                              )}
                              data={props.platesEvidence.filter(
                                (x) => x.evidenceType === "verificationStub"
                              )}
                              defaultSortField=""
                              noHeader={true}
                              dense
                              highlightOnHover
                              pointerOnHover
                              pagination
                              paginationComponentOptions={paginationOptions}
                              noDataComponent={
                                <p className={classes.marginNoData}>
                                  {t("commonMessages.noData")}
                                </p>
                              }
                            />
                          </Grid>
                        </Container>

                        <Grid item xs={12}>
                          <WhiteSpace size="lg" />
                        </Grid>
                      </Grid>
                    </Grid>
                  )}
                </Grid>
                <Grid container className={classes.containerWithBorderRound}>
                  <Grid item xs={12} className={classes.gridColor1}>
                    <h5 className={classes.textColorWhite}>Entrega</h5>
                  </Grid>
                  {
                    <Grid item xs={12}>
                      {props.orderDetail.deliveryTentativeDateStatus === 2 && (
                        <p className={classes.rejectedComment}>
                          {props.orderDetail.deliveryTentativeDateComment}
                        </p>
                      )}
                    </Grid>
                  }
                  <Grid container item xs={12} spacing={3}>
                    <Grid item xs={12}>
                      <WhiteSpace size="lg" />
                    </Grid>
                    <Grid item xs={6} className={classes.alignRight}>
                      <h5>Forma de entrega</h5>
                    </Grid>
                    <Grid item xs={6} className={classes.alignCenter}>
                      <h5>
                        {props.orderDetail.deliveryForm
                          ? props.orderDetail.deliveryForm
                          : "---"}
                      </h5>
                    </Grid>
                  </Grid>
                  <Grid container item xs={12} spacing={3}>
                    <Grid item xs={6} className={classes.alignRight}>
                      <h5>Fecha de entrega programada</h5>
                    </Grid>
                    <Grid item xs={6} className={classes.alignCenter}>
                      <DatePicker
                        placeholder="Seleccione Fecha"
                        onChange={handleTentativeDeliveryDate}
                        defaultValue={deliveryTentativeDate}
                        className={
                          disabledDeliveryTentativeDate ? "" : "classname"
                        }
                        disabled={disabledDeliveryTentativeDate}
                      />
                    </Grid>
                  </Grid>
                  <Grid item xs={12} className={classes.alignCenter}>
                    <WhiteSpace size="lg" />
                    <WhiteSpace size="lg" />
                    <Button
                      size="small"
                      onClick={handleTentativeDeliveryDateSubmit}
                      disabled={disabledDeliveryTentativeDate}
                      variant="contained"
                      color="primary"
                    >
                      Guardar fecha
                    </Button>
                  </Grid>
                  <Grid item xs={12} className={classes.alignCenter}>
                    <WhiteSpace size="lg" />
                    <WhiteSpace size="lg" />
                  </Grid>
                </Grid>
              </TabPanel>
            )}
            {!isOCA && showtabs && (
              <TabPanel value={value} index={4}>
                <Grid container className={classes.containerWithBorderRound}>
                  <Grid item xs={12} className={classes.gridColor1}>
                    <h5 className={classes.textColorWhite}>Entrega</h5>
                  </Grid>
                  {
                    <Grid item xs={12}>
                      {props.orderDetail.deliveryDateStatus === 2 && (
                        <p className={classes.rejectedComment}>
                          {props.orderDetail.deliveryDateComment}
                        </p>
                      )}
                    </Grid>
                  }
                  <Grid item xs={12}>
                    <br />
                    <br />
                  </Grid>
                  <Grid item xs={12} className={classes.alignCenter}>
                    <Button
                      onClick={handleDownloadFileAnexoB}
                      variant="contained"
                      disabled={disableBtn}
                      color="primary"
                    >
                      Descargar Anexo B
                    </Button>
                                    </Grid>
                  <Grid item xs={12}>
                    <br />
                    <br />
                  </Grid>
                  <Grid container item xs={12} spacing={3}>
                    <Grid item xs={4} className={classes.alignRight}>
                      <h5 style={{ marginTop: "7px" }}>
                        Cargar Anexo B &nbsp;
                      </h5>
                    </Grid>
                    <Grid item xs={5} className={classes.alignCenter}>
                      <FormControl fullWidth>
                        <Input
                          type="file"
                          name="annexB"
                          id="annexB"
                          onChange={onChangeHandlerAnnexB}
                          disabled={disabledAnnexButton}
                          startAdornment={
                            <InputAdornment position="start">
                              <InboxIcon />
                            </InputAdornment>
                          }
                        />
                      </FormControl>
                    </Grid>
                    <Grid item xs={3} className={classes.alignLeft}>
                      <Button
                        style={{ border: "0px" }}
                        title="Cargar"
                        onClick={handleAnnexbSubmit}
                        disabled={disabledAnnexButton}
                      >
                        <CloudUploadIcon />
                      </Button>
                    </Grid>
                  </Grid>
                  <Grid item xs={12}>
                    <br />
                  </Grid>
                  {props.orderDetail.annexB && (
                    <Grid container item xs={12} spacing={3}>
                      <Grid item xs={12} className={classes.alignCenter}>
                        <h6> {props.orderDetail.annexB}</h6>
                      </Grid>
                    </Grid>
                  )}
                  <Grid item xs={12}>
                    <br />
                  </Grid>
                  <Grid container item xs={12} spacing={3}>
                    <Grid item xs={4} className={classes.alignRight}>
                      <h5>Fecha real de entrega &nbsp;</h5>
                    </Grid>
                    <Grid item xs={8} className={classes.alignLeft}>
                      <DatePicker
                        placeholder="Seleccione Fecha"
                        onChange={handleRealDeliveryDate}
                        defaultValue={deliveryDate}
                        className={disabledDeliveryDates ? "" : "classname"}
                        disabled={disableDt}
                      />
                    </Grid>
                  </Grid>
                  <Grid container item xs={12} spacing={3}>
                    <Grid item xs={4} className={classes.alignRight}>
                      <h5>Hora &nbsp;</h5>
                    </Grid>
                    <Grid item xs={8} className={classes.alignLeft}>
                      <TimePicker
                        placeholder="Hora"
                        defaultValue={moment(
                          deliveryDate
                            ? new Date(
                              props.orderDetail.deliveryDate
                            ).toTimeString()
                            : "00:00:00",
                          "HH:mm:ss"
                        )}
                        format="HH:mm:ss"
                        onChange={handleHourChange}
                        disabled={disableDt}
                      />
                    </Grid>
                  </Grid>
                  <Grid item xs={12} className={classes.alignCenter}>
                    <WhiteSpace size="lg" />
                    <WhiteSpace size="lg" />
                    <Button
                      size="small"
                      onClick={handleDeliveryDate}
                      disabled={disableDt}
                      variant="contained"
                      color="primary"
                    >
                      Guardar Entrega
                    </Button>
                  </Grid>
                  <Grid item xs={12}>
                    <br />
                    <br />
                  </Grid>
                </Grid>
              </TabPanel>
            )}
            {showtabs && (
              <TabPanel value={value} index={5}>
                <Grid container className={classes.containerWithBorderRound}>
                  <Grid item xs={12} className={classes.gridColor1}>
                    <h5 className={classes.textColorWhite}>Mensajes</h5>
                  </Grid>
                  <Grid item xs={12}>
                    <Table sx={{ minWidth: 700 }} aria-label="customized table">
                      <TableBody>
                        {props.notifications.map((row) => (
                          <StyledTableRow
                            key={row.subProcessActionCdDesc}
                            className={getRowClassName(
                              row.supplierNotifReadInd
                            )}
                          >
                            <StyledTableCell scope="row">
                              {row.subProcessActionCdDesc}
                            </StyledTableCell>
                            <StyledTableCell align="left">
                              {row.nvpCommentDesc}
                            </StyledTableCell>
                            <StyledTableCell align="right">
                              {new Date(row.auditInsertDt).toLocaleString() +
                                "  EST"}
                            </StyledTableCell>
                            <StyledTableCell align="right" hidden={true}>
                              {row.supplierNotifReadInd}
                            </StyledTableCell>
                          </StyledTableRow>
                        ))}
                      </TableBody>
                    </Table>
                    <TablePagination
                      rowsPerPageOptions={[10, 25, 100]}
                      component="div"
                      count={props.notifications.length}
                      rowsPerPage={rowsPerPage}
                      page={page}
                      onPageChange={handleChangePage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <br />
                    <br />
                  </Grid>
                </Grid>
              </TabPanel>
            )}
            <WhiteSpace size="lg" />
            <WhiteSpace size="lg" />
          </Grid>
        </Container>
        <WhiteSpace size="lg" />
        <WhiteSpace size="lg" />
        <br />
      </Container>
      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"¿Desea guardar la fecha real de entrega?"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Al dar clic en el botón "GUARDAR" ya no podrá editar la fecha real
            de entrega
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDeliveryDateSubmit} color="primary">
            Guardar
          </Button>
          <Button onClick={handleCloseDialog} color="primary" autoFocus>
            Cancelar
          </Button>
        </DialogActions>
      </Dialog>
      <ToastContainer />
    </div>
  );
};

const mapStateToProps = (state) => ({
  userProfile: state.UserProfileReducer.list,
  orderDetail: state.PurchaseReducer.OrderDetail,
  TokenNVP: state.PurchaseReducer.TokenNVP,
  platesEvidence: state.PurchaseReducer.platesEvidence,
  isUserAuthenticated: state.LoginReducer.isAuthenticated,
  userToken: state.LoginReducer.token,
  userLanguage: state.LoginReducer.language,
  notificationStatus: state.NotificationsReducer.NotificationStatus,
  notifications: state.NotificationsReducer.Notifications,
  xxx: state.LoginReducer,
});

const mapDispatchToProps = (dispatch) => {
  return {
    tokenExpired: () => dispatch({ type: "TOKEN_EXPIRED" }),
    cleanUserProfile: () => dispatch({ type: "CLEAN_USER_PROFILE" }),
    purchaseActions: bindActionCreators(purchaseActions, dispatch),
    navigationActions: bindActionCreators(navigationActions, dispatch),
    notificationActions: bindActionCreators(notificationActions, dispatch),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(PurchaseStyles)(PurchaseOrderDetail));
